import Vue from 'vue'
import Router from 'vue-router'
import { HTTP } from '../util/axios';
import * as response from '../util/response';
import Cookie from 'js-cookie'
import { api } from '@/config'
import * as login from '@/util/login'
/*代入组件*/

// import Home from '@/components/home'
// import Forbidden from '@/components/common/Forbidden'
// import OrderStatus from '@/components/views/OrderStatus'
// import MyOrder from '@/components/views/MyOrder'
// import SearchResult from '@/components/views/SearchResult'
// import HomeIndex from '@/components/views/HomeIndex'
// import Evaluate from '@/components/views/Evaluate'
// import BannerDetail from '@/components/views/BannerDetail'//BannerDetail
// import ConfirmOrder from '@/components/views/ConfirmOrder' //确认订单页
// import StopService from '@/components/common/StopService'
// /*出错页面*/
// import NoOrder from '@/components/errorPages/NoOrder' //没有订单
// import E404 from '@/components/errorPages/e-404' //404
// import Result from '@/components/errorPages/NoResult' //404
const Home = resolve => require(['@/components/home'], resolve)
const Forbidden = resolve => require(['@/components/common/Forbidden'], resolve)
const OrderStatus = resolve => require(['@/components/views/OrderStatus'], resolve)
const MyOrder = resolve => require(['@/components/views/MyOrder'], resolve)
const SearchResult = resolve => require(['@/components/views/SearchResult'], resolve)
const HomeIndex = resolve => require(['@/components/views/HomeIndex'], resolve)
const Evaluate = resolve => require(['@/components/views/Evaluate'], resolve)
const BannerDetail = resolve => require(['@/components/views/BannerDetail'], resolve)
const ConfirmOrder = resolve => require(['@/components/views/ConfirmOrder'], resolve)
const StopService = resolve => require(['@/components/common/StopService'], resolve)
const NoOrder = resolve => require(['@/components/errorPages/NoOrder'], resolve)
const E404 = resolve => require(['@/components/errorPages/e-404'], resolve)
const Result = resolve => require(['@/components/errorPages/NoResult'], resolve)

Vue.use(Router)

const router = new Router({
  routes: [{
    path: '/',
    component: Home,
    children: [
      // { path: '/stopServiceForShiYu', component: HomeIndex, name: '' },
      // { path: '/', component: StopService, name: '' },
      { path: '/', component: HomeIndex, name: '' },
      { path: '/stopService', component: StopService, name: '' },
      { path: '/OrderStatus', component: OrderStatus, name: '' },
      { path: '/MyOrder', component: MyOrder, name: '' },
      { path: '/SearchResult', component: SearchResult, name: '' },
      { path: '/HomeIndex', component: HomeIndex, name: '' },
      { path: '/Evaluate', component: Evaluate, name: '' },
      { path: '/403', component: Forbidden },
      { path: '/NoOrder', component: NoOrder },
      { path: '/e-404', component: E404 },
      { path: '/NoResult', component: Result },
      { path: '/BannerDetail', component: BannerDetail, name: 'BannerDetail' },
      { path: '/ConfirmOrder' , component: ConfirmOrder, name: '' },
    ],
    scrollBehavior: () => ({ y: 0 }),
  }]
})
//获取地址权限借口
var getArea = function (next, data) {
  var data = {
    flag: 1
  }
  HTTP.get('/area/queryList', { params: data })
    .then(res => {
      var code = res.data.status.code;
      Vue.prototype.$userArea = {};
      if (code == 200 && res.data.data) {
        var response = res.data.data;
        if (response.menuId && response.floorId) {
          localStorage.setItem('menuId', response.menuId);
          localStorage.setItem('arriveAddress', response.arriveAddress);
          localStorage.setItem('floorId', response.floorId); //localStorage保存楼层信息
          Vue.prototype.$userArea = response;
          next();
        } else {
          next();
        }
      } else {
        next();
      }
    })
}
//调取借口判断是否有权限
const judgePower = function (next, to) {
  HTTP.get('/area/queryList')
    .then(res => {
      var code = res.data.status.code;
      if (code == 403) {
        next('/403')
        return;
      } else if (code == 200) {
        getArea(next, to)
      }else{
        next();
      }
    })
}


/* 路由拦截（钩子）*/
router.beforeEach((to, from, next) => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
  if (to.path == '/403') {
    next();
  } else {
    //校验checkCode开关
    if (api.mall.on) {
      //checkCode检查
      login.checkLogin(() => {//失败回调
        router.push('403');
      }, () => {//成功回调
        judgePower(next, to);
        // getArea(next, to)        
      });
    } else {
      next();
    }
  }
})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js